"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CryptoTooltip = void 0;
var _cryptoConstraints = require("@ppay/crypto-constraints");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var _ui = require("../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Tooltip = (0, _styledComponents.default)(_ui.Tooltip)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .tooltip-inner {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n  }\n"])));
var CryptoTooltip = function CryptoTooltip(_ref) {
  var hash = _ref.hash,
    blockchain = _ref.blockchain,
    className = _ref.className,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libTransactionsTable']),
    t = _useTranslation.t;
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  var ref = _react.default.useRef(null);
  var blockchainExplorer = _cryptoConstraints.BlockchainExplorer[blockchain];
  var onClick = hash ? function (e) {
    e.stopPropagation();
    window.open(blockchainExplorer.link + hash, '_blank');
  } : undefined;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: "d-inline-flex flex-lg-column m-0 flex-nowrap ".concat(className),
    role: hash && 'button',
    ref: ref
  }, children, hash && isTablet && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u2192")), !isTablet && blockchain && /*#__PURE__*/_react.default.createElement(Tooltip, {
    placement: "bottom",
    target: ref
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('network'), ": ", blockchainExplorer === null || blockchainExplorer === void 0 ? void 0 : blockchainExplorer.network), hash && /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('libTransactionsTable:clickToShowOn'), " ", /*#__PURE__*/_react.default.createElement(_ui.Link, null, blockchainExplorer.title))));
};
exports.CryptoTooltip = CryptoTooltip;